export const getToken = () => {
  const tokenValues = document.cookie.match(/token=(.+?)(;|$)/);

  if (tokenValues) {
    return tokenValues[1];
  }
  return null;
};
